import ReportEditInsights from './reportEditInsights'
export default ReportEditInsights
